import styled from "@emotion/styled";
import { Button, Text, Variables, copyIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, useToast } from "@repo/ui";
import { type MouseEvent } from "react";

const Container = styled(FlexDiv)`
  gap: ${Variables.space25};
  align-items: center;
  min-width: 0;
`;

export const CopyText = ({
  text,
  buttonTitle,
  successMessage,
}: {
  text: string;
  buttonTitle?: string; // hove text
  successMessage?: string;
}) => {
  const { updateToast } = useToast();

  const onCopyText = async (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      updateToast({
        title: successMessage ?? t("prompt.copied"),
      });
    } catch {
      updateToast({
        type: "error",
        title: t("prompt.something_went_wrong"),
      });
    }
  };

  return (
    <Container>
      <Text noWrap ellipsis>
        {text}
      </Text>

      <Button
        iconOnly
        ssrIcon={copyIcon}
        text={buttonTitle}
        title={buttonTitle ?? t("action.copy")}
        size="xsmall"
        type="tertiary"
        onClick={onCopyText}
      />
    </Container>
  );
};
